import { getCurrentInstance } from 'vue';

const componentExists = (name) => {
    var _a, _b, _c;
    return name in ((_c = (_b = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.appContext) === null || _b === void 0 ? void 0 : _b.components) !== null && _c !== void 0 ? _c : {});
};
const normalizeCssClassesRecord = (classes) => {
    return Object.keys(classes).filter(k => classes[k]);
};
const normalizeCssClasses = (classes) => {
    const result = [];
    if (Array.isArray(classes)) {
        classes.forEach(classes => {
            if (typeof classes === 'string') {
                result.push(classes);
            }
            else {
                result.push(...normalizeCssClassesRecord(classes));
            }
        });
    }
    else {
        result.push(...normalizeCssClassesRecord(classes));
    }
    return result;
};

export { componentExists, normalizeCssClasses };
